import { momentToString } from '@shared/innmaxLib/utils/webHelper'
import { cond } from 'ramda'
import { INotification, INotificationRes } from './notification.type'

export const useNotificationConverter = () => {
  return (notification: INotificationRes): INotification => {
    return {
      ...notification,
      createAtStr: momentToString(notification.createAt),
      eventStr: cond<any[], string>([
        [n => n === 'CHARGE_80', () => '充電達80%'],
        [n => n === 'CHARGE_100', () => '充電完成'],
        [n => n === 'OCCUPY', () => '車位被佔用'],
        [() => true, () => '未知事件'],
      ])(notification.event),
    }
  }
}
